@defer (prefetch on idle) {
  <ng-content></ng-content>
} @loading (minimum 0.5s) {
  <app-loading></app-loading>
}
